import styled from "styled-components";

export const PersonalInfoNoMemberFormStyled = styled.div`
  .form_title {
    margin-bottom: 32px;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
  }
  .input_wrap {
    margin-bottom: 18px;
    &.mb_32 {
      margin-bottom: 32px;
    }
    .field_rec {
      margin-top: 8px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    }
  }
  .warning_text {
    margin-bottom: 12px;
    color: ${({ theme }) => theme.COLORS.RED_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S13};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  }
`;
